import { shallowMount } from "@vue/test-utils";
import OfertaTCCA from "@/views/OfertaTCCA";

describe("OfertaTCCA component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OfertaTCCA);
  });

  it("Renders del component OfertaTCCA", () => {
    expect(wrapper).toBeDefined();
  });
});
